import * as React from 'react';

import moment from 'moment';

import {Checkbox} from 'shells/checkbox/checkbox';
import {FormField} from 'shells/form/form-field';
import {PopoverInfo} from 'shells/popover-info/popover-info';
import {useDidMountEffect} from 'shells/utils/hooks/use-did-mount-effect';

import type {SmsDripSequenceFragment as DripSequence} from 'nutshell-graphql-types';

import {SentFromField} from '../../SentFromField';

import styles from './drip-sequences-details-form.module.css';

type Props = {
    dripSequence: DripSequence;
    onDripSave: (saveData: any) => Promise<any>;
};

export function DripSequencesDetailsForm(props: Props) {
    const [isBusinessHoursOnly, setIsBusinessHoursOnly] = React.useState<boolean>(
        props.dripSequence.isBusinessHoursOnly
    );

    useDidMountEffect(() => {
        props.onDripSave({
            id: props.dripSequence.id,
            isBusinessHoursOnly,
        });
    }, [props.dripSequence.id, isBusinessHoursOnly]);

    return (
        <form
            onSubmit={(event) => {
                event.preventDefault();

                props.onDripSave({
                    id: props.dripSequence.id,
                    isBusinessHoursOnly,
                });
            }}
            className={styles.container}
        >
            <div>
                <FormField innerId='from' label='Sending from:'>
                    <SentFromField from={props.dripSequence.from} />
                </FormField>
                <FormField innerId='businessHoursOnly'>
                    <Checkbox
                        checked={isBusinessHoursOnly}
                        label='Only send messages during business hours'
                        onChange={(newValue) => {
                            setIsBusinessHoursOnly(newValue);
                        }}
                        helpComponent={
                            <PopoverInfo
                                info={getBusinessHoursTooltipContent()}
                                size={18}
                                bodyColor='dark'
                            />
                        }
                        isLarge={true}
                    />
                </FormField>
            </div>
        </form>
    );
}

function getBusinessHoursTooltipContent() {
    const businessHoursStart = moment(
        NutshellFrontendSettings.businessHours.start,
        NutshellFrontendSettings.businessHours.format
    )
        .format('h:mma')
        .toString();

    const businessHoursEnd = moment(
        NutshellFrontendSettings.businessHours.end,
        NutshellFrontendSettings.businessHours.format
    )
        .format('h:mma')
        .toString();

    return (
        <>
            Only send drip messages during your team’s business hours:{' '}
            <b>
                M-F, {businessHoursStart} - {businessHoursEnd}
            </b>
        </>
    );
}
